import { CartOfferLine } from '~shared/modules/shopping-cart-store';
import { ITotal } from '~shared/modules/cart/models';

export interface SelectDiscountCode {
  applied: boolean;
  value: string;
  error: string;
  code: string;
  loading: boolean;
}

export interface ShoppingCartData {
  offers: CartOfferLine[],
  totals: ITotal,
  currency: string,
}

export const EMPTY_CART_DATA: ShoppingCartData = {
  offers: [],
  totals: {
    shippingCostTotal: 0,
    subTotal: 0,
    subTotalTax: 0,
    total: 0,
    valueAddedServicesTotal: '0.00',
    valueAddedServicesTotalNet: '0.00',
  },
  currency: 'EUR'
}
